<template>
  <div class="modal" v-bind:class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="container">

      <!-- Multi-object detail display -->
      <div v-if="Array.isArray(details.objects)" class="archive-details">
        <div class="archive-details__header">
          <h2 class="archive-details__title title is-4 is-marginless" v-html="titleText(details)"></h2>
          <a @click="closeModal"
              class="archive-details__close-icon"
              aria-label="close">
            <span class="icon">
              <i class="ion ion-md-close" aria-hidden="true"></i>
            </span>
          </a>
        </div>

        <div class="archive-details__body">
          <div v-if="details.caption"
               v-html="markdown(details.caption)"
               class="archive-details__body__row is-fullwidth">
          </div>

          <!-- Loop through all "objects" in "details" prop -->
          <div v-for="(object, objIndex) in details.objects"
                :key="`obj-${objIndex}`"
                :data-index="objIndex + 1"
                class="archive-details__body__row">
            <img :src="imagePath(object)" class="image"/>

            <div class="">
              <h2 class="title is-5"><span class="" v-html="titleText(object)"></span>, {{ displayDate(object) }}</h2>
              <h3 class="subtitle is-6">{{ displayType(object) }}</h3>
              <div v-html="descriptionText(object)"></div>
              <hr />
              <div class="is-size-7" v-html="tombstoneText(object)"></div>
              <br/>

              <div class="field is-grouped">
                <div class="control">
                  <button class="button is-light">View Object</button>
                </div>
                <div class="control">
                  <button class="button is-light is-outlined">View in Getty Collection</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Single-object detail display -->
      <div v-else class="archive-details">
        <div class="archive-details__header">
          <h2 class="archive-details__title title is-4 is-marginless"></h2>
          <a @click="closeModal"
             class="archive-details__close-icon"
             aria-label="close">
            <span class="icon">
              <i class="ion ion-md-close" aria-hidden="true"></i>
            </span>
          </a>
        </div>
        <div class="archive-details__body">
          <div class="archive-details__body__row">
            <div>
              <img :src="imagePath(details)" class="image">
            </div>
            <div>
              <h2 class="title is-5"><span class="" v-html="titleText(details)"></span>, {{ displayDate(details) }}</h2>
              <h3 class="subtitle is-6">{{ displayType(details) }}</h3>
              <div class="" v-html="descriptionText(details)"></div>
              <br/>
              <div class="field is-grouped">
                <div class="control">
                  <button class="button is-outlined">View Object</button>
                </div>
                <div class="control">
                  <button class="button is-light is-outlined">View in Getty Collection</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MONTHS, markdown } from '@/utils.js'

export default {
  name: 'archiveDetails',
  props: ['isActive', 'details'],
  computed: {
    ...mapGetters(['chapter'])
  },

  methods: {
    closeModal () {
      if (this.isActive) {
        this.$emit('close-details')
      }
    },

    // the markdown function will output the text to include <p>
    // tags, they aren't needed in the title, so are stripped here
    titleText (object) {
      if (object.title) {
        let str = this.markdown(object.title)
        return str.replace(/<\/*p>/g, '').trim()
      } else {
        return ''
      }
    },

    descriptionText (object) {
      if (object.caption) {
        return this.markdown(object.caption)
      } else {
        return ''
      }
    },

    tombstoneText (object) {
      if (object.tombstone) {
        return this.markdown(object.tombstone)
      } else {
        return ''
      }
    },

    displayDate (object) {
      if (object.date_string) {
        return object.date_string
      } else {
        let date = new Date(object.date)
        return `${MONTHS[date.getMonth()]} ${date.getFullYear()}`
      }
    },

    displayType (object) {
      let displayString = ''

      switch (object.display) {
        case 'single-page':
          if (Array.isArray(object.filename)) {
            displayString = 'Collection of single-sided pages'
          } else {
            displayString = 'Single-sided page'
          }
          break

        case 'recto-verso':
          if (Array.isArray(object.filename)) {
            displayString = 'Collection of double-sided pages'
          } else {
            displayString = 'Double-sided page'
          }
          break

        case 'bound':
          displayString = 'Bound publication.'
          break
      }

      return displayString
    },

    imagePath (object) {
      if (object.filename) {
        if (Array.isArray(object.filename)) {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${object.filename[0]}`)
        } else {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${object.filename}`)
        }
      } else {
        return false
      }
    },

    markdown: markdown
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/main.scss";

.archive-details {
  background-color: $grey-dark;

  &__header {
    border-bottom: solid 1px $black-ter;
    width: 100%;
  }

  &__title {
    min-height: 3.5rem;
    padding: 1rem;
  }

  &__close-icon {
    padding: 1rem;
    position: absolute;
    top: 0;
    right: 0;
  }

  &__body {
    max-height: 80vh;
    overflow-y: scroll;
    position: relative;
    width: 100%;

    clear: both;

    &__row {
      border-bottom: solid 1px $black-ter;
      display: grid;
      grid-auto-rows: minmax(80px, auto);
      grid-column-gap: 2rem;
      grid-template-columns: 1fr 2fr;
      padding: 2rem;

      &.is-fullwidth {
        grid-template-columns: 1fr;
      }
    }
  }
}


</style>




// WEBPACK FOOTER //
// src/components/ArchiveDetails.vue?b70ba7d8